var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 0.222229H0.222221V16.2222H16.2222V0.222229Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8094 7.01583C13.8094 8.8711 13.0657 10.5527 11.8602 11.7787L15.8055 15.1603C15.9972 15.3246 16.0194 15.6132 15.8551 15.8049C15.6907 15.9966 15.4022 16.0188 15.2105 15.8545L11.2475 12.4577C11.2216 12.4355 11.1988 12.4109 11.1791 12.3847C10.0291 13.2777 8.58455 13.8094 7.01582 13.8094C3.26382 13.8094 0.222221 10.7678 0.222221 7.01583C0.222221 3.26383 3.26382 0.222229 7.01582 0.222229C10.7678 0.222229 13.8094 3.26383 13.8094 7.01583ZM9.75091 4.28113C9.57239 4.1026 9.28293 4.10259 9.10442 4.28111L7.01582 6.36957L4.92727 4.28111C4.74876 4.10259 4.45929 4.1026 4.28077 4.28113C4.10225 4.45966 4.10226 4.74913 4.28079 4.92765L6.36933 7.01601L4.28095 9.10429C4.10242 9.2828 4.10241 9.57222 4.28093 9.75078C4.45945 9.92929 4.7489 9.92929 4.92741 9.75078L7.01582 7.6625L9.10423 9.75078C9.28275 9.92929 9.57221 9.92929 9.75072 9.75078C9.92924 9.57222 9.92924 9.2828 9.75072 9.10429L7.66236 7.01601L9.75086 4.92765C9.92942 4.74913 9.92942 4.45966 9.75091 4.28113Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search-empty.b0cc4c05cf4e6943886f109c79f3a2cb.svg";
export { ForwardRef as ReactComponent };